// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"535":"8c97aafb","646":"225163a8","940":"7dae64a1"}[chunkId] + ".js";
};